export default __webpack_public_path__ + "static/media/updateProgressStart.ac2cc3db.svg";